import getOrganizationDisplayName from './getOrganizationDisplayName';
import type { Language } from '../types/common';
import type { OptionsType } from '../types/options';
import type { OrganizationType } from '../types/organization';
import type { OrganizationUserType } from '../types/user';

interface Options {
  organizationBases?: OptionsType[];
  tradingCompanies?: OptionsType[];
  language?: Language;
}

const defaultOption: Options = {
  organizationBases: undefined,
  tradingCompanies: undefined,
  language: undefined,
};

/**
 * ユーザ組織から組織の表示名を返す。該当する商社が見つからなかったら商社コードをそのまま帰す。
 * @param tradingCompanyCode [string]
 * @param option [Options]
 * @returns [string]
 */
const getOrganizationDisplayNameByOrganizationUser = (organizationUser: OrganizationUserType | undefined, organizations: OrganizationType[] | undefined, option: Options = {}): string => {
  const mergedOption: Options = { ...defaultOption, ...option };
  const { organizationBases, tradingCompanies, language } = mergedOption;
  if (organizationUser) {
    // 組織情報の取得
    const organization: OrganizationType | undefined = organizations?.find((org) => org.id === organizationUser.organizationId);
    // console.log(organizationUser, organizations, organization);
    if (organization) {
      const orgName: string = getOrganizationDisplayName(organization, { organizationBases, tradingCompanies, language });
      return orgName;
    } else {
      return 'ORG ID: ' + (organizationUser.organizationId ?? '?');
    }
  } else {
    return '';
  }
};

export default getOrganizationDisplayNameByOrganizationUser;
